import {IObjectModelEntryPerformActionResponse, IServerData} from "../interfaces/serverInterfaces";
import {HTTPMethod} from "./new/httpMethod";
import {IProviderRoutes} from "../interfaces/provider";
import Provider from "./new/provider";
import {Constructor} from "../../global/constructor";
import BaseObjectModelEntry from "../models/objectModelEntries/baseObjectModelEntry";
import {Route} from "../enums/route";
import {RouteHelper} from "../helpers/routeHelper";
import {Hash} from "~/interfaces/hashInterfaces";

interface IObjectModelEntryProviderRoutes {
  search: string,
  performAction?: string,
  changeRecordHolder?: string
  resendClaimRecordNotification?: string
  resendAccountRelationClaimRecordNotification?: string
  createEntryShell?: string
  fetchEntryRelationsAndEntries?: string;
  checkForEntryRelation?: string;
}

export default class ObjectModelEntryProvider<T extends BaseObjectModelEntry = BaseObjectModelEntry> extends Provider<T> {
  routes: IProviderRoutes & IObjectModelEntryProviderRoutes;
  fakeRoutes: IProviderRoutes & IObjectModelEntryProviderRoutes = Object.assign({}, this.routes);

  constructor(protected modelType: Constructor<T>, public modelRoot: string, public collectionRoot: string, private fakeMode: boolean = false) {
    super(modelType, modelRoot, collectionRoot);
    let newRoutes: IObjectModelEntryProviderRoutes = {
      search: RouteHelper.path({route: Route.objectModelEntries}),
      performAction: RouteHelper.path({route: Route.objectModelEntriesPerformAction}),
      changeRecordHolder: RouteHelper.path({route: Route.objectModelEntriesChangeHolder}),
      resendClaimRecordNotification: RouteHelper.path({route: Route.objectModelEntriesResendClaimRecordNotification}),
      resendAccountRelationClaimRecordNotification: RouteHelper.path({route: Route.objectModelEntriesResendAccountRelationClaimRecordNotification}),
      createEntryShell: RouteHelper.path({route: Route.objectModelEntriesCreateShell}),
      fetchEntryRelationsAndEntries: RouteHelper.path({route: Route.fetchEntryRelationsAndEntries}),
      checkForEntryRelation: RouteHelper.path({route: Route.checkForEntryRelation}),
    };
    let newFakeRoutes: IObjectModelEntryProviderRoutes = {
      search: RouteHelper.path({route: Route.objectModelFakeEntries}),
    };
    Object.assign(this.fakeRoutes, this.routes);
    Object.assign(this.routes, newRoutes);
    Object.assign(this.fakeRoutes, newFakeRoutes);
  }

  async changeHolder({object_model_id,entry_id , owner_email }: {object_model_id: string ,entry_id: string, owner_email: string}){
    const json =  {};
    json['owner_email'] = owner_email;
    return this.serverAction<Hash>({
      endpoint: this.replace(this.getRoutes.changeRecordHolder, {object_model_id, entry_id }),
      method: HTTPMethod.POST,
      json
    });
  }
  performAction({object_model_id, entry_id, action_id, data}: {object_model_id: string, entry_id: string, action_id: string, data?: object}): Promise<IServerData<IObjectModelEntryPerformActionResponse>> {
    const json = data ?? {};
    json['action_id'] = action_id;
    return this.serverAction({
      endpoint: this.replace(this.getRoutes.performAction, {object_model_id, entry_id}),
      method: HTTPMethod.POST,
      json,
    });
  }

  resendClaimRecordNotification({object_model_id, entry_id}: {object_model_id: string, entry_id: string}) {
    const json = {};
    return this.serverAction<any>({
      endpoint: this.replace(this.getRoutes.resendClaimRecordNotification, {object_model_id, entry_id}),
      method: HTTPMethod.POST,
      json,
    });
  }
  
  resendAccountRelationClaimRecordNotification({object_model_id, entry_id, account_relation_client_id, user_email}: {object_model_id: string, entry_id: string, account_relation_client_id: string, user_email: string}) {
    const json = { account_relation_client_id, user_email };
    return this.serverAction<any>({
      endpoint: this.replace(this.getRoutes.resendAccountRelationClaimRecordNotification, {object_model_id, entry_id}),
      method: HTTPMethod.POST,
      json,
    });
  }

  fetchEntryRelationsAndEntries({entryId, publishedRelationId, inverse, page}: {entryId: string, publishedRelationId: string, inverse: boolean, page?: number}) {
    const json = {
      inverse: inverse,
      published_relation_id: publishedRelationId,
      page: page || 0,
    }
    return this.serverAction<any>({
      endpoint: this.replace(this.getRoutes.fetchEntryRelationsAndEntries, {id: entryId}),
      method: HTTPMethod.GET,
      json,
    });
  }

  checkForEntryRelation({publishedRelationId, entryId, inverse}: {publishedRelationId: string, entryId: string, inverse: boolean}) {
    const json = {
      inverse: inverse,
      entry_id: entryId,
    }
    return this.serverAction<any>({
      endpoint: this.replace(this.getRoutes.checkForEntryRelation, {id: publishedRelationId}),
      method: HTTPMethod.GET,
      json,
    });
  }

  async createShell({object_model_id}): Promise<IServerData<any>> {
    return this.serverAction({
      endpoint: this.replace(this.getRoutes.createEntryShell, {object_model_id}),
      method: HTTPMethod.POST,
    })
  }

  private get getRoutes(): this['routes'] | this['fakeRoutes'] {
    return this.fakeMode ? this.fakeRoutes : this.routes;
  }

  replacer(route: string, obj: object, metadata: object = {}): string {
    const objectModelId = obj['object_model_id'];
    route = route.replace(':object_model_id', objectModelId);
    if (obj['entry_id']) {
      route = route.replace(':entry_id', obj['entry_id']);
    }
    return route;
  }
}
